import React, { HTMLProps, memo } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { isMiniappSelector } from 'src/selectors/app';
import { DOMAIN_URL } from 'src/constants';
interface IProps extends HTMLProps<HTMLElement> {
    to: string;
    title?: string;
    as?: string;
    newTab?: boolean;
    alt?: string;
    onClick?: (evt: any) => any;
}

export const RouterLink = React.forwardRef((props: IProps, ref: any) => {
    const {
        to,
        title = '',
        className = '',
        children,
        newTab = false,
        style = {},
        onClick,
    } = props;
    const isIframe = useSelector(isMiniappSelector);

    const _onClick = (evt: React.MouseEvent) => {
        if (onClick) {
            onClick(evt);
            return;
        }
        if (!newTab) {
            return;
        }
        if (isIframe) {
            window.parent.postMessage(
                { type: 'OPEN_LINK_FROM_BAOMOI', url: DOMAIN_URL + to },
                'https://h5.zdn.vn',
            );
        } 
    };

    if (!to) {
        return (
            <div
                className={className}
                style={style}
                onClick={_onClick}
                ref={ref}
            >
                {children}
            </div>
        );
    }

    return (
        <Link passHref as={to} href={to}>
            <a
                ref={ref}
                style={style}
                className={className}
                title={title}
                onClick={_onClick}
                target={newTab ? '_blank' : undefined}
                rel={newTab ? 'noopener noreferrer' : undefined}
            >
                {children}
            </a>
        </Link>
    );
});
export default memo(RouterLink);
